<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Permission Group</h3>

            <div class="search_bar mb-3">
                <b-button
                    class="btn-action"
                    size="sm"
                    variant="info"
                    :to="{
                        name: 'cms_permission_group_add'
                    }"
                    v-if="
                        $store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Permission Group',
                                'Create',
                                true
                            )
                    "
                    >Add Permission Group</b-button
                >
            </div>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(client_name)="data">
                    {{ data.item.client_name || '-' }}
                </template>
                <template v-slot:cell(action)="data">
                    <b-button
                        class="btn-action"
                        size="sm"
                        variant="info"
                        :to="{
                            name: 'cms_permission_group_edit',
                            params: { permission_group_id: data.item.id }
                        }"
                        v-if="
                            $store.state.user_obj &&
                                checkPermission(
                                    $store.state.user_obj,
                                    'Account',
                                    'Permission Group',
                                    'Edit',
                                    true
                                )
                        "
                        >Edit</b-button
                    >

                    <b-button
                        class="btn-action"
                        size="sm"
                        variant="danger"
                        @click="showModal_confirmDelete(data.item)"
                        v-if="
                            $store.state.user_obj &&
                                checkPermission(
                                    $store.state.user_obj,
                                    'Account',
                                    'Permission Group',
                                    'Delete',
                                    true
                                )
                        "
                        >Delete</b-button
                    >
                </template>
            </b-table>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
                <div class="d-block">
                    <b-row class="mb-3">
                        <b-col>Are you sure to delete this permission group?</b-col>
                    </b-row>
                </div>
                <div class="text-right">
                    <b-btn
                        class="mt-3"
                        variant="outline-danger"
                        @click="hideModal_confirmDelete"
                        >Cancel</b-btn
                    >
                    <b-btn
                        class="mt-3"
                        variant="outline-success"
                        @click="deleteUser()"
                        >Confirm</b-btn
                    >
                </div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "id",
        label: "User ID"
    },
    {
        key: "name",
        label: "Name"
    },
    {
        key: "action",
        label: "Action"
    }
];

export default {
    name: "ProductMaster",
    mixins: [global_function],
    inject: [
        "API_HOST",
        "TABLE_LIMIT",
        "PAGING_LIMIT",
        "DEFAULT_ROWS_PER_PAGE"
    ],
    components: {
        Pagination
    },
    data() {
        return {
            upload_file: [],
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            //   table_offset: 0,
            total_rows: 0,
            rows_per_page: this.DEFAULT_ROWS_PER_PAGE,
            paging_limit: this.PAGING_LIMIT,
            search_criteria: {}
        };
    },
    async created() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Permission Group',
            'View',
            true
        )) {
            this.$router.replace('/');
            return;
        }

        await this.getPermissionGroups();
        this.initialized = true;
    },
    mounted() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Permission Group',
            'View',
            true
        )) {
            return;
        }

        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    computed: {
        table_offset: function() {
            return (this.currentPage - 1) * this.rows_per_page;
        }
    },
    methods: {
        async getPermissionGroups() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_group_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.rows_per_page,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.items = response.data.permission_groups;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
        },

        onSearch() {
          for (const key in this.search_criteria) {
            if (typeof this.search_criteria[key] === "string") {
              this.search_criteria[key] = this.search_criteria[key].trim();
            }
          }
            this.getPermissionGroups();
        },

        onPageChange(page_to_change) {
            this.currentPage = page_to_change;
            this.getPermissionGroups();
        },

        onPerPageChange(_perPage) {
            this.currentPage = 1;
            this.rows_per_page = _perPage;
            this.getPermissionGroups();
        },

        showModal_confirmDelete(item) {
            this.$refs.modal_confirmDelete.item = item;
            this.$refs.modal_confirmDelete.show();
        },

        hideModal_confirmDelete() {
            this.$refs.modal_confirmDelete.hide();
        },

        async deleteUser() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_group_delete.php",
                data: {
                    permission_group_id: this.$refs.modal_confirmDelete.item.id,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.getPermissionGroups();
            this.hideModal_confirmDelete();
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsPermissionGroup.vue